<template>
  <div>
    <div class="text" v-html="getSubProcessSelected.content.StaticInfo"></div>
    <v-expansion-panels accordion>
      <v-expansion-panel v-for="(item, i) in getSubProcessSelected.content.SectionsInfo" :key="i">
        <v-expansion-panel-header><strong>{{item.title}}</strong></v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="text" v-html="item.content"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getSubProcessSelected"]),
  },
};
</script>

<style>
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
}
</style>